import UtilService from "../../services/UtilService";

export function getColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "firstName",
            headerName: "First name",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "lastName",
            headerName: "Last name",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "subject",
            headerName: "Subject",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "ipAddr",
            headerName: "IP Addr",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "createdAt",
            headerName: "Created",
            flex: 1,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return UtilService.formatDate(params.value);
            },
        },
    ];
}
